<template>
    <div class="navbar-item">
        <router-link
            :to="url"
            class="p-2"
        >
            <div class="flex items-center">
                <div style="width: 68px;"  v-html="methodColor(method)"></div>
                <div class="whitespace-no-wrap">{{name}}</div>
            </div>
        </router-link>
    </div>
</template>

<script>
import {mixins} from '../../mixins'
export default {
    mixins: [mixins],
    props: {
        name: {
            type: String,
            required: true
        },
        url: {
            type: String,
            required: true
        },
        method: {
            type: String,
            required: true
        }
    },
}
</script>

<style lang="scss">
.navbar-item {
    a {
        display: block;
    }
}
</style>
